import AuiButton from "../../components/Buttons/Buttons";
import {
  SessionStatusConstants,
  SessionStatusTypes,
} from "../../utils/constants/session-status-constants";

interface TrainingSessionInfoProps {
  trainingSession: {
    status?: string;
    trainingInstance?: any[];
  };
  userRole: string;
  getTrainingStatus: () => SessionStatusTypes;
  replacePlaceholders: (msg: string) => string;
  handleInProgressStatus: (msg: string) => string;
  hasFeedbackReminderMessage: () => boolean;
  getFeedbackReminderMessage: () => string;
  showSendReminder: () => boolean;
  handleSendReminder: () => void;
}

const TrainingSessionStatusMessage: React.FC<TrainingSessionInfoProps> = ({
  trainingSession,
  userRole,
  getTrainingStatus,
  replacePlaceholders,
  handleInProgressStatus,
  hasFeedbackReminderMessage,
  getFeedbackReminderMessage,
  showSendReminder,
  handleSendReminder,
}) => {
  const status = getTrainingStatus();
  let statusInfo = SessionStatusConstants[status]?.statusInfo[userRole];

  if (!statusInfo) return null;
  if (!Array.isArray(statusInfo)) {
    statusInfo = [statusInfo];
  }

  statusInfo = statusInfo.map(replacePlaceholders).map(handleInProgressStatus);
  const isSingleInstance = trainingSession?.trainingInstance?.length === 1;

  return isSingleInstance || statusInfo.length === 1 ? (
    <p
      className={
          hasFeedbackReminderMessage() &&
          statusInfo[0] === getFeedbackReminderMessage()
            ? "reminder-message"
            : ""
      }
    >
      {statusInfo[0]}{" "}
      {showSendReminder() && (
        <AuiButton
          variant="link-style-arrow"
          buttontitle="Send Reminder"
          size="small"
          onClick={() => {
            if (!hasFeedbackReminderMessage()) {
              handleSendReminder();
            }
          }}
          disabled={hasFeedbackReminderMessage()}
          buttonclass={hasFeedbackReminderMessage() ? "disabled" : ""}
          buttonid="SendReminder"
        />
      )}
    </p>
  ) : (
    <ul className="statusMsgList">
      {statusInfo.map((message: any) => (
        <li key={message.id}>
          <span
            className={
                hasFeedbackReminderMessage() &&
                message === getFeedbackReminderMessage()
                  ? "reminder-message"
                  : ""
            }
          >
            {message}
          </span>
          {message.includes("coordinator workbook") && showSendReminder() && (
            <AuiButton
              variant="link-style-arrow"
              buttontitle="Send Reminder"
              size="small"
              buttonid="SendReminder"
              onClick={() => {
                if (!hasFeedbackReminderMessage()) {
                  handleSendReminder();
                }
              }}
              disabled={hasFeedbackReminderMessage()}
              buttonclass={hasFeedbackReminderMessage() ? "disabled" : ""}
            />
          )}
        </li>
      ))}
    </ul>
  );
};

export default TrainingSessionStatusMessage;
